import React from 'react';
import { IconCircleQuestion } from '../components/ui-kit/icons';
import { Alert } from '../components/ui-kit';

class MoreInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDetailed: false
    };
  }

  toggleContent = () => {
    this.setState({ showDetailed: !this.state.showDetailed });
  };

  render = () => (
    <Alert onMouseEnter={this.toggleContent} onMouseLeave={this.toggleContent}>
      {this.state.showDetailed ? (
        <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
      ) : (
        <>
          <IconCircleQuestion /> {this.props.label}
        </>
      )}
    </Alert>
  );
}

export default MoreInfo;
